// Package Imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
// Project Imports
import routeName from 'core/common/routeName';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

const HookEventActionsPage = lazy(() => import('pages/hookEvents/actions'));
const HookEventList = lazy(() => import('pages/hookEvents/list'));

const HookEventRoute = (
  <Route path={routeName.hookEvent}>
    <Route
      index
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.ALL_HOOK_EVENT_VIEW,
            PrivateRouteConst.SELF_HOOK_EVENT_VIEW,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <HookEventList />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="create"
      element={
        // <PrivateRoute name={PrivateRouteConst.CREATE_HOOK_EVENT}>
        <Suspense fallback={<Loading />}>
          <HookEventActionsPage type="Create" />
        </Suspense>
        // </PrivateRoute>
      }
    />
    <Route
      path="edit/:id"
      element={
        // <PrivateRoute
        //   name={[
        //     PrivateRouteConst.ALL_HOOK_EVENT_EDIT,
        //     PrivateRouteConst.SELF_HOOK_EVENT_EDIT,
        //   ]}
        // >
        <Suspense fallback={<Loading />}>
          <HookEventActionsPage type="Edit" />
        </Suspense>
        // </PrivateRoute>
      }
    />
    <Route
      path="show/:id"
      element={
        // <PrivateRoute
        //   name={[
        //     PrivateRouteConst.ALL_HOOK_EVENT_VIEW,
        //     PrivateRouteConst.SELF_HOOK_EVENT_VIEW,
        //   ]}
        // >
        <Suspense fallback={<Loading />}>
          <HookEventActionsPage type="Show" />
        </Suspense>
        // </PrivateRoute>
      }
    />
  </Route>
);

export default HookEventRoute;
